import { convertDurationToTime } from '@repo/ui/src/functions/video-functions';
import YoutubePlay from '@repo/ui/src/components/Icons/YoutubePlayIcon';

interface Props {
  title?: string;
  duration?: string | number;
  imgUrl?: string;
  onClick?: () => void;
}

const VideoThumbnail = ({ imgUrl, title, duration, onClick }: Props) => (
  <button
    className="tw-relative tw-w-full tra-btn-bare"
    onClick={onClick}
    aria-label={`Play ${title} video`}
  >
    {imgUrl && <img src={imgUrl} alt="" className="tw-w-full tw-aspect-video tw-object-cover" />}
    {duration && (
      <span className="tw-absolute tw-bottom-3 tw-right-3 tw-px-2 tw-bg-neutral-600 tw-rounded tw-text-white">
        <span className="sr-only">Video Duration: </span>
        {convertDurationToTime(Number(duration))}
      </span>
    )}
    {imgUrl && (
      <div className="tw-absolute tw-w-[75px] tw-h-[75px] tw-translate-x-[-50%] tw-translate-y-[-50%] tw-left-1/2 tw-top-1/2">
        <YoutubePlay color="#fff" height="auto" uniqueId={title} shadow />
      </div>
    )}
  </button>
);

export default VideoThumbnail;
